// Small shared form controls reused across custom indicator config modals
// (CupHandleConfigModal, WilliamOneilSellConfigModal, ...). Kept intentionally
// tiny/local rather than a generic form library, matching how the rest of
// this codebase builds each config modal's UI bespoke.

export function NumberField({
  label, hint, value, onChange, min, max, step = 1, suffix, disabled,
}: {
  label: string;
  hint?: string;
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  step?: number;
  suffix?: string;
  disabled?: boolean;
}) {
  return (
    <div className={`flex items-center justify-between gap-3 ${disabled ? 'opacity-40 pointer-events-none' : ''}`}>
      <div className="flex flex-col min-w-0">
        <span className="text-sm text-modal-text">{label}</span>
        {hint && <span className="text-xs text-modal-muted">{hint}</span>}
      </div>
      <div className="flex items-center gap-1.5 shrink-0">
        <input
          type="number"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => {
            const n = Number(e.target.value);
            if (!Number.isNaN(n)) onChange(Math.min(max, Math.max(min, n)));
          }}
          className="w-20 text-sm bg-panel border border-border rounded px-2 py-1.5 text-modal-text outline-none focus:border-accent text-center"
        />
        {suffix && <span className="text-xs text-modal-muted w-4">{suffix}</span>}
      </div>
    </div>
  );
}

export function ToggleSwitch({
  checked, onChange, label, hint,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  hint?: string;
}) {
  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
        checked ? 'bg-accent' : 'bg-border'
      }`}
    >
      <span
        className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${
          checked ? 'translate-x-4' : 'translate-x-1'
        }`}
      />
    </button>
  );
  if (!label) return button;
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex flex-col min-w-0">
        <span className="text-sm text-modal-text font-medium">{label}</span>
        {hint && <span className="text-xs text-modal-muted">{hint}</span>}
      </div>
      {button}
    </div>
  );
}
